import { Theme, useMediaQuery } from '@mui/material';

const useIsMobile = () =>
  useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

export default useIsMobile;
